module.exports = __webpack_public_path__ + "media/images/processing-01373c8e5ddb28a239b745aa3621b477.png";